import http from '../../../utils/http';

interface SearchParams {
  query?: boolean;
}

export function search(params: SearchParams) {
  return http.get('api/search', { params });
}
